import React, { useState } from "react";
import { powersearch } from "../services/api"; // Adjust the import path as necessary

const Frame1010108758 = () => {
  const [searchText, setSearchText] = useState("");
  const [responseText, setResponseText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [language, setLanguage] = useState("EN");

  const languageMap = {
    EN: "gb",
    DE: "de",
    IT: "it",
    FR: "fr",
    ES: "es",
    PT: "pt",
    NL: "nl",
    PL: "pl",
  };

  const toggleLanguage = () => {
    const languages = Object.keys(languageMap);
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    setLanguage(languages[nextIndex]);
  };
  // Add input sanitization
  const sanitizeInput = (input) => {
    return input.replace(/[<>'"]/g, "");
  };

  const handleSearch = async () => {
    if (searchText.trim()) {
      const sanitizedQuery = sanitizeInput(searchText);
      setIsLoading(true);
      try {
        const countryCode = languageMap[language];
        // Add authentication header if implementing auth
        const response = await powersearch(
          sanitizedQuery,
          3,
          "",
          countryCode,
          true,
          {
            headers: {
              Authorization: `Bearer auth`, // TODO ${authToken}, // If using auth
              "Content-Type": "application/json",
            },
          }
        );
        if (response && response.results) {
          // Your Flask route returns { "results": "..." }
          const results = response.results;

          if (typeof results === "string") {
            setResponseText(results);
          } else if (Array.isArray(results)) {
            // If results is an array, format it nicely
            setResponseText(
              results.length > 0
                ? results
                    .map(
                      (item, index) =>
                        `${index + 1}. ${JSON.stringify(item, null, 2)}`
                    )
                    .join("\n\n")
                : "No results found."
            );
          } else if (typeof results === "object") {
            // If results is an object, stringify it
            setResponseText(JSON.stringify(results, null, 2));
          } else {
            setResponseText(String(results));
          }
        } else {
          // Fallback for unexpected response format
          setResponseText(
            typeof response === "string"
              ? response
              : JSON.stringify(response, null, 2)
          );
        }
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setResponseText("Please enter a search term.");
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div
      data-layer="Webapp"
      className="Webapp"
      style={{
        width: 1276,
        height: 1600,
        position: "relative",
        background: "white",
        overflow: "auto",
      }}
    >
      <div
        data-layer="Frame 1010108761"
        className="Frame1010108761"
        style={{
          width: 1110,
          height: 1523,
          left: 83,
          top: 30,
          position: "absolute",
          backgroundImage:
            "url(/media/system_files/img/6_techpro-2_print1.png)",
          backgroundRepeat: "no-repeat",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 10,
          display: "inline-flex",
        }}
      >
        <div
          data-layer="AI search component"
          className="AiSearchComponent"
          style={{
            width: 780,
            height: 1780,
            left: 155,
            top: 120,
            position: "absolute",
            background: "white",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 20,
            display: "flex",
          }}
        >
          <div
            data-layer="header"
            className="Header"
            style={{
              alignSelf: "stretch",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: 5,
              display: "flex",
            }}
          >
            <div
              data-layer="Topbar"
              className="Topbar"
              style={{
                alignSelf: "stretch",
                height: 30,
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 98,
                display: "inline-flex",
              }}
            >
              <div
                data-layer="Frame 1010108744"
                className="Frame1010108744"
                style={{
                  flex: "1 1 0",
                  alignSelf: "stretch",
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div
                  data-layer="Frame 1010108747"
                  className="Frame1010108747"
                  style={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                />
                <div
                  data-layer="Frame 1010108746"
                  className="Frame1010108746"
                  style={{
                    flex: "1 1 0",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                />
                <div
                  data-layer="Frame 1010108748"
                  className="Frame1010108748"
                  style={{
                    flex: "1 1 0",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                />
              </div>

              <div
                data-layer="Button"
                className="Button"
                style={{
                  width: 120,
                  alignSelf: "stretch",
                  paddingLeft: 15,
                  paddingRight: 15,
                  paddingTop: 10,
                  paddingBottom: 10,
                  background: "#00205B",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 10,
                  display: "inline-flex",
                }}
              >
                <div
                  data-layer="path7924"
                  className="Path7924"
                  style={{
                    width: 59,
                    height: 13,
                    background: "#00205B",
                    backgroundImage: "url(/media/system_files/img/MAHLE.png)",
                  }}
                />
              </div>
              <div
                data-layer="Frame 1010108743"
                className="Frame1010108743"
                style={{
                  width: 217,
                  alignSelf: "stretch",
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <div
                  data-layer="Frame 1010108747"
                  className="Frame1010108747"
                  style={{
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                >
                  <div
                    data-svg-wrapper
                    data-layer="bluetooth"
                    data-style="Outlined"
                    className="Bluetooth"
                    style={{ position: "relative" }}
                  >
                    <svg
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.4718 5.31875L7.90308 1.75H7.27808V6.49375L4.40933 3.625L3.52808 4.50625L7.02183 8L3.52808 11.4938L4.40933 12.375L7.27808 9.50625V14.25H7.90308L11.4718 10.6813L8.78433 8L11.4718 5.31875ZM8.52808 4.14375L9.70308 5.31875L8.52808 6.49375V4.14375ZM9.70308 10.6813L8.52808 11.8563V9.50625L9.70308 10.6813Z"
                        fill="#00205B"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  data-layer="Frame 1010108746"
                  className="Frame1010108746"
                  style={{
                    flex: "1 1 0",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                >
                  <div
                    data-layer="0.29.269.140"
                    className="29269140"
                    style={{
                      color: "#00205B",
                      fontSize: 12,
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      wordWrap: "break-word",
                    }}
                  >
                    0.29.269.140
                  </div>
                </div>
                <div
                  data-layer="Frame 1010108748"
                  className="Frame1010108748"
                  style={{
                    flex: "1 1 0",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 10,
                    display: "flex",
                  }}
                >
                  <div
                    data-layer="05:47 PM"
                    className="47Pm"
                    style={{
                      color: "#00205B",
                      fontSize: 12,
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      wordWrap: "break-word",
                    }}
                  >
                    05:47 PM
                  </div>
                </div>
              </div>
            </div>
            <div
              data-layer="headbar"
              className="Headbar"
              style={{
                alignSelf: "stretch",
                height: 30,
                paddingLeft: 20,
                paddingRight: 20,
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 17,
                display: "inline-flex",
              }}
            >
              <div
                data-layer="connection"
                className="Connection"
                style={{
                  width: 30,
                  height: 30,
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 10,
                  display: "flex",
                }}
              >
                <div
                  data-svg-wrapper
                  data-layer="settings_remote"
                  data-style="Outlined"
                  className="SettingsRemote"
                  style={{ position: "relative" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.005 9.5H9.00498C8.45498 9.5 8.00498 9.95 8.00498 10.5V22.5C8.00498 23.05 8.45498 23.5 9.00498 23.5H15.005C15.555 23.5 16.005 23.05 16.005 22.5V10.5C16.005 9.95 15.555 9.5 15.005 9.5ZM14.005 21.5H10.005V11.5H14.005V21.5Z"
                      fill="#00205B"
                    />
                    <path
                      d="M12.005 14.5C12.5573 14.5 13.005 14.0523 13.005 13.5C13.005 12.9477 12.5573 12.5 12.005 12.5C11.4527 12.5 11.005 12.9477 11.005 13.5C11.005 14.0523 11.4527 14.5 12.005 14.5Z"
                      fill="#00205B"
                    />
                    <path
                      d="M7.05498 6.55L8.46498 7.96C9.37498 7.06 10.625 6.5 12.005 6.5C13.385 6.5 14.635 7.06 15.545 7.96L16.955 6.55C15.685 5.28 13.935 4.5 12.005 4.5C10.075 4.5 8.32498 5.28 7.05498 6.55ZM12.005 0.5C8.96498 0.5 6.21498 1.73 4.22498 3.72L5.63498 5.13C7.26498 3.51 9.51498 2.5 12.005 2.5C14.495 2.5 16.745 3.51 18.365 5.14L19.775 3.73C17.795 1.73 15.045 0.5 12.005 0.5Z"
                      fill="#00205B"
                    />
                  </svg>
                </div>
              </div>
              <div
                data-layer="question"
                className="Question"
                style={{
                  width: 30,
                  height: 30,
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 10,
                  display: "flex",
                }}
              >
                <div
                  data-svg-wrapper
                  data-layer="help_outline"
                  data-style="Outlined"
                  className="HelpOutline"
                  style={{ position: "relative" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
                      fill="#00205B"
                    />
                  </svg>
                </div>
              </div>
              <div
                data-layer="menu"
                className="Menu"
                style={{
                  width: 30,
                  height: 30,
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 10,
                  display: "flex",
                }}
              >
                <div
                  data-svg-wrapper
                  data-layer="density_medium"
                  data-style="Outlined"
                  className="DensityMedium"
                  style={{ position: "relative" }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M21 3H3V5H21V3Z" fill="#00205B" />
                    <path d="M21 19H3V21H21V19Z" fill="#00205B" />
                    <path d="M21 11H3V13H21V11Z" fill="#00205B" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div
            data-layer="AI search"
            className="AiSearch"
            style={{
              height: 1700,
              alignSelf: "stretch",
              alignSelf: "stretch",
              paddingLeft: 70,
              paddingRight: 70,
              paddingTop: 10,
              paddingBottom: 10,
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 10,
              display: "inline-flex",
            }}
          >
            <div
              data-layer="Ai search header"
              className="AiSearchHeader"
              style={{
                alignSelf: "stretch",
                height: 177,
                padding: 10,
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 10,
                display: "flex",
              }}
            >
              <div
                data-layer="Frame 1010108738"
                className="Frame1010108738"
                style={{
                  alignSelf: "stretch",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 32,
                  display: "flex",
                }}
              >
                <div
                  data-layer="Text"
                  className="Text"
                  style={{
                    alignSelf: "stretch",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 21,
                    display: "flex",
                  }}
                >
                  <div
                    data-layer="Welcome to TechPro2 AI Search"
                    className="WelcomeToTechpro2AiSearch"
                  >
                    <span
                      style={{
                        color: "#00205B",
                        fontSize: 43,
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        wordWrap: "break-word",
                      }}
                    >
                      Welcome to TechPro2{" "}
                    </span>
                    <span
                      style={{
                        color: "#00205B",
                        fontSize: 43,
                        fontFamily: "Roboto",
                        fontWeight: "800",
                        wordWrap: "break-word",
                      }}
                    >
                      AI Search
                    </span>
                  </div>
                  <div
                    data-layer="Explore hundreds of vehicles, functions and more to start your diagnose."
                    className="ExploreHundredsOfVehiclesFunctionsAndMoreToStartYourDiagnose"
                    style={{
                      alignSelf: "stretch",
                      textAlign: "center",
                      color: "#1E2A63",
                      fontSize: 14,
                      fontFamily: "Roboto",
                      fontWeight: "600",
                      wordWrap: "break-word",
                    }}
                  >
                    Explore hundreds of vehicles, functions and more to start
                    your diagnose.
                  </div>
                </div>
                <div
                  data-layer="Input"
                  className="Input"
                  style={{
                    alignSelf: "stretch",
                    height: 32,
                    paddingLeft: 50,
                    paddingRight: 50,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 16,
                    display: "inline-flex",
                  }}
                >
                  {/* Language Toggle Button */}
                  <div
                    data-layer="Language Button"
                    className="LanguageButton"
                    onClick={toggleLanguage}
                    style={{
                      alignSelf: "stretch",
                      paddingLeft: 16,
                      paddingRight: 16,
                      paddingTop: 10,
                      paddingBottom: 10,
                      background: "#00205B",
                      borderRadius: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      data-layer="Language"
                      className="Language"
                      style={{
                        color: "white",
                        fontSize: 13,
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        wordWrap: "break-word",
                      }}
                    >
                      {language}
                    </div>
                  </div>
                  <div
                    data-layer="Input line"
                    className="InputLine"
                    style={{
                      flex: "1 1 0",
                      alignSelf: "stretch",
                      padding: 10,
                      background: "white",
                      boxShadow:
                        "0px 4.369747638702393px 4.369747638702393px rgba(0, 0, 0, 0.25)",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                    }}
                  >
                    <div
                      data-layer="Frame 1010108762"
                      className="Frame1010108762"
                      style={{
                        flex: "1 1 0",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 10,
                        display: "flex",
                      }}
                    >
                      <div
                        data-svg-wrapper
                        data-layer="search"
                        data-style="Outlined"
                        className="Search"
                        style={{ position: "relative" }}
                      >
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.1356 16.4718H17.2725L16.9667 16.1769C18.0372 14.9315 18.6818 13.3147 18.6818 11.5559C18.6818 7.63401 15.5028 4.45502 11.5809 4.45502C7.65909 4.45502 4.4801 7.63401 4.4801 11.5559C4.4801 15.4777 7.65909 18.6567 11.5809 18.6567C13.3398 18.6567 14.9566 18.0122 16.202 16.9416L16.4969 17.2475V18.1105L21.9591 23.5617L23.5868 21.934L18.1356 16.4718ZM11.5809 16.4718C8.86077 16.4718 6.66498 14.276 6.66498 11.5559C6.66498 8.83569 8.86077 6.63989 11.5809 6.63989C14.3011 6.63989 16.4969 8.83569 16.4969 11.5559C16.4969 14.276 14.3011 16.4718 11.5809 16.4718Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                      <input
                        type="text"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="PLATE / VIN / ENGINE CODE"
                        style={{
                          flex: "1 1 0",
                          border: "none",
                          outline: "none",
                          color: "#5C5C5C",
                          fontSize: 13,
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          width: "100%",
                          background: "transparent",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    data-layer="Button"
                    className="Button"
                    onClick={handleSearch}
                    style={{
                      alignSelf: "stretch",
                      paddingLeft: 16,
                      paddingRight: 16,
                      paddingTop: 10,
                      paddingBottom: 10,
                      background: "#00205B",
                      borderRadius: 2,
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                      display: "flex",
                      cursor: "pointer",
                    }}
                  >
                    <div
                      data-layer="Search"
                      className="Search"
                      style={{
                        color: "white",
                        fontSize: 13,
                        fontFamily: "Roboto",
                        fontWeight: "600",
                        wordWrap: "break-word",
                      }}
                    >
                      {isLoading ? "Searching..." : "Search"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-layer="Ai search fooder"
              className="AiSearchFooder"
              style={{
                alignSelf: "stretch",
                flex: "1 1 0",
                paddingTop: 15,
                paddingBottom: 30,
                paddingLeft: 50,
                paddingRight: 50,
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 10,
                display: "flex",
              }}
            >
              <div
                data-layer="Frame 1010108755"
                className="Frame1010108755"
                style={{
                  alignSelf: "stretch",
                  flex: "1 1 0",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 10,
                  display: "flex",
                }}
              >
                <div
                  data-layer="Sentences"
                  data-property-1="Response"
                  className="Sentences"
                  style={{
                    alignSelf: "stretch",
                    flex: "1 1 0",
                    padding: 10,
                    background: "#F5F5F5",
                    borderRadius: 3,
                    justifyContent: "center",
                    alignItems: "flex-start",
                    gap: 10,
                    display: "inline-flex",
                    overflow: "auto", // Make scrollable
                    height: "1500px",
                  }}
                >
                  <div
                    className="ResponseText"
                    style={{
                      flex: "1 1 0",
                      color: "#323232",
                      fontSize: 12,
                      fontFamily: "Roboto",
                      fontWeight: "400",
                      wordWrap: "break-word",
                      whiteSpace: "pre-wrap", // Preserve formatting
                    }}
                  >
                    {responseText}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frame1010108758;
